/**
 * Retry configuration for session list queries.
 * Uses exponential backoff to handle transient failures
 * (e.g. stale auth tokens after desktop app update, network warmup).
 */
export const SESSIONS_QUERY_RETRY_DELAY = (attemptIndex: number) =>
  Math.min(1000 * 2 ** attemptIndex, 10_000);
